import favorites from '../services/favorites';

export default function () {
    const element = document.querySelector('.js-favorite-number');

    if (!element) {
        return;
    }

    const handleFavoritesChange = () => {
        element.textContent = favorites.getFavoritePerformances().length + favorites.getFavoriteArtists().length;
    }

    window.addEventListener(favorites.favoritePerformancesChangedEventName, handleFavoritesChange);
    window.addEventListener(favorites.favoriteArtistsChangedEventName, handleFavoritesChange);

    handleFavoritesChange();
}
